import { inject, Injectable, Renderer2 } from "@angular/core";
import { ServerProxyService } from "./server-proxy.service";
import { DepositFundsRequest, DepositFundsResponse } from "../types/deposit-funds.type";
import { AppData } from "../data";

@Injectable({ providedIn: 'root' })
export class PaymentsService {

  private _data = inject(AppData);
  private _proxies = inject(ServerProxyService);

  private _script: HTMLScriptElement | null = null;

  public async loadPayments({ document, renderer }: { document: Document, renderer: Renderer2 }) {
    //  test token: 'Kq8WVv-82yeQ6-CQvm9f-tR3rxT'
    const dataTokenizationKey = this._data.route.creditCardDataTokenizationKey;
    if (!dataTokenizationKey) {
      throw new Error('Please provide a Data Tokenization Key');
    }
    //  Configure can only be called once (never creates the fields on subsequent calls)
    //  so we have to reload the script from scratch every time we load the credit card form
    //  (Seems to be a bug in the nmi implementation since their docs indicate we should be able to reconfigure as many times as we want)
    if (this._script) { renderer.removeChild(document.body, this._script); }
    return new Promise((resolve, reject) => {
      this._script = renderer.createElement('script');
      this._script.src = 'https://secure.nmi.com/token/Collect.js';
      this._script.setAttribute('data-tokenization-key', dataTokenizationKey);
      this._script.onload = async () => { resolve(true); };
      this._script.onerror = (error: any) => reject(error);
      renderer.appendChild(document.body, this._script);
    });
  }

  public updateBalance(request: DepositFundsRequest): Promise<DepositFundsResponse> {
    return this._proxies.depositFunds(request);
  }

}
